import { useEffect, useRef, useState, useContext } from "react";

import styles from './MediasoupConferenceComponentNew.module.css'

import { GlobalContext } from "../../contexts/globalContext"

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ParticipantStreamComponent from "./ParticipantStreamComponent";

import io from "socket.io-client";
import { Device } from 'mediasoup-client'


function MediasoupConferenceComponentNew() {

    const {
        currentConference, appHeight, currentParticipant, setCurrentModeratorStream, currentTopic, setCurrentParticipantStream,
        currentParticipantStream, participantsStreams, setParticipantsStreams, ioSettings, iamSubAdministrator,
        setAlertMessage
    } = useContext(GlobalContext)

    const videoStreamsRef = useRef()
    const socketRoomRef = useRef()
    const remoteVideosContainerRef = useRef()
    const currentTopicRef = useRef()

    const [videoElementHeight, setVideoElementHeight] = useState([]);
    const [videoMuted, setVideoMuted] = useState(false);
    const [micMuted, setMicMuted] = useState(false);

    let params = {
        encodings: [
            {
                rid: 'r0',
                maxBitrate: 100000,
                scalabilityMode: 'S1T3',
            },
            {
                rid: 'r1',
                maxBitrate: 300000,
                scalabilityMode: 'S1T3',
            },
            {
                rid: 'r2',
                maxBitrate: 900000,
                scalabilityMode: 'S1T3',
            },
        ],
        // https://mediasoup.org/documentation/v3/mediasoup-client/api/#ProducerCodecOptions
        codecOptions: {
            videoGoogleStartBitrate: 1000
        }
    }

    const videoParamsRef = useRef();
    const audioParamsRef = useRef();
    let consumingTransports = [];

    let device;
    let rtpCapabilities;
    let producerTransport;
    let consumerTransports = [];
    let audioProducer;
    let videoProducer;

    useEffect(() => {
        currentTopicRef.current = currentTopic;

        // la pres ce se intampla? 

        if (currentConference.type !== "Presentation") {
            if (currentTopic && videoStreamsRef.current) {
                var currVideo = videoStreamsRef.current.find(element => element.participant._id === currentTopic?.moderator || element.participant._id === currentTopic?.moderator._id);
                if (currVideo) {
                    setCurrentModeratorStream(currVideo);
                }
            } else {
                setCurrentModeratorStream(null);
            }

            if (currentTopic?.moderator._id === currentParticipant?._id && currentParticipantStream) {
                setCurrentModeratorStream({ remoteProducerId: "local", participant: currentParticipant, stream: currentParticipantStream });
            }
        }

    }, [currentTopic])

    useEffect(() => {
        videoStreamsRef.current = participantsStreams;
        // de ce trebuie sa avem current topic?
        if (videoStreamsRef.current && currentTopic) {

            var currModerator = videoStreamsRef.current.find(mod => mod.participant._id === currentTopic?.moderator._id || mod.participant._id === currentTopic?.moderator);
            if (currModerator) {

                setCurrentModeratorStream(currModerator);
            } else {
                if (currentTopic?.moderator._id !== currentParticipant?._id) {
                    setCurrentModeratorStream(null);
                }
            }
        }
    }, [participantsStreams])


    useEffect(() => {

        if (ioSettings && ioSettings.audio) {
            setMicMuted(ioSettings.micMuted)
        }

        if (ioSettings && ioSettings.video) {
            setVideoMuted(ioSettings.videoMuted)
        }

        setVideoElementHeight(appHeight / 10);

        socketRoomRef.current = io.connect(process.env.REACT_APP_MEDIASOUP_URL, { secure: true, reconnect: true, rejectUnauthorized: false })
        socketRoomRef.current.pingTimeout = 1000;
        socketRoomRef.current.pingInterval = 3000;

        socketRoomRef.current.on('connection-success', () => {
            GetLocalStream();

        })

        socketRoomRef.current.on('new-producer', ({ producerId }) => signalNewConsumerTransport(producerId))

        socketRoomRef.current.on('producer-closed', ({ remoteProducerId }) => {
            // server notification is received when a producer is closed
            // we need to close the client-side consumer and associated transport
            const producerToClose = consumerTransports.find(transportData => transportData.producerId === remoteProducerId)
            if (producerToClose) {
                producerToClose.consumerTransport.close()
                producerToClose.consumer.close()
            }

            // remove the consumer transport from the list
            consumerTransports = consumerTransports.filter(transportData => transportData.producerId !== remoteProducerId)

            // remove the video div element

            setParticipantsStreams(prev =>
                prev.map(p => {
                    let updated = { ...p };

                    if (p.audioRemoteProducerId === remoteProducerId) {
                        delete updated.audioStream;
                        delete updated.audioRemoteProducerId;
                    }

                    if (p.videoRemoteProducerId === remoteProducerId) {
                        delete updated.videoStream;
                        delete updated.videoRemoteProducerId;
                    }

                    return updated;
                })
                    .filter(p => p.audioStream || p.videoStream)
            );
        })

        socketRoomRef.current.on("disconnect", () => {

            setParticipantsStreams([])

            device = null;
            rtpCapabilities = null;

            producerTransport?.close();
            producerTransport = null;

            for (let index = 0; index < consumerTransports.length; index++) {
                const element = consumerTransports[index];
                element.consumerTransport.close();
            }

            audioParamsRef.current = {};
            videoParamsRef.current = { params };

            consumerTransports = [];
            consumingTransports = [];
            audioProducer?.close();
            videoProducer?.close();
            audioProducer = null;
            videoProducer = null;

        });

        audioParamsRef.current = {};
        videoParamsRef.current = { params };

        return () => {
            socketRoomRef.current.close();
        }
    }, [])

    const GetLocalStream = () => {
        console.log("ioSettings", ioSettings)
        if (ioSettings) {
            navigator.mediaDevices.getUserMedia(ioSettings)
                .then(StreamSuccess)
                .catch(error => {
                    //setAlertMessage({ type: "ERROR", message: "Error joining media server: " + error.message, forever: true });
                })
        } else {
            // var iamModerator = (currentConference?.type === "Conference" && currentConference?.topics[0]?.moderator._id === currentParticipant._id) ||
            //     iamSubAdministrator ||
            //     ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant._id === currentConference.moderatedBy);
            var iamModerator = (currentConference?.type === "Conference" && currentConference?.topics[0]?.moderator._id === currentParticipant?._id) ||
                iamSubAdministrator ||
                ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant?._id === currentConference.moderatedBy);

            navigator.mediaDevices.getUserMedia({
                audio: iamModerator,
                //video: true
                video: {
                    facingMode: "user",
                    width: {
                        min: 640,
                        max: 960,
                    },
                    height: {
                        min: 400,
                        max: 540,
                    }
                }
            })
                .then(StreamSuccess)
                .catch(error => {
                    //setAlertMessage({ type: "ERROR", message: "Error joining media server: " + error.message, forever: true });
                })
        }
    }

    const StreamSuccess = (stream) => {
        setCurrentParticipantStream(stream);

        if (currentTopicRef.current?.moderator._id === currentParticipant?._id) {
            setCurrentModeratorStream({ remoteProducerId: "local", participant: currentParticipant, stream });
        }

        if (ioSettings) {
            if (ioSettings.audio) {
                audioParamsRef.current = { track: stream.getAudioTracks()[0], ...audioParamsRef.current };
                if (ioSettings.micMuted) {
                    audioParamsRef.current.track.enabled = false;
                }

            }
            if (ioSettings.video) {
                videoParamsRef.current = { track: stream.getVideoTracks()[0], ...videoParamsRef.current };
                if (ioSettings.videoMuted) {
                    videoParamsRef.current.track.enabled = false;
                }
            }
        } else {
            videoParamsRef.current = { track: stream.getVideoTracks()[0], ...videoParamsRef.current };

            var iamModerator = (currentConference?.type === "Conference" && currentConference?.topics[0]?.moderator._id === currentParticipant?._id) ||
                iamSubAdministrator ||
                ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant?._id === currentConference.moderatedBy);

            if (iamModerator) {
                audioParamsRef.current = { track: stream.getAudioTracks()[0], ...audioParamsRef.current };
            }
        }


        JoinRoom();
    }

    const JoinRoom = () => {
        socketRoomRef.current.emit('joinRoom', { roomName: currentConference._id, clientId: currentParticipant?._id }, (data) => {
            // we assign to local variable and will be used when
            // loading the client Device (see createDevice above)
            rtpCapabilities = data.rtpCapabilities

            // once we have rtpCapabilities from the Router, create Device
            CreateDevice()
        })
    }

    const CreateDevice = async () => {
        try {
            device = await Device.factory({ handlerName: "Chrome111" });

            // https://mediasoup.org/documentation/v3/mediasoup-client/api/#device-load
            // Loads the device with RTP capabilities of the Router (server side)
            await device.load({
                // see getRtpCapabilities() below
                routerRtpCapabilities: rtpCapabilities
            })

            // once the device loads, create transport
            CreateSendTransport()
        } catch (error) {
            console.log("CreateDevice", error);
        }
    }

    const CreateSendTransport = () => {
        // see server's socket.on('createWebRtcTransport', sender?, ...)
        // this is a call from Producer, so sender = true
        socketRoomRef.current.emit('createWebRtcTransport', { consumer: false }, ({ params }) => {
            // The server sends back params needed 
            // to create Send Transport on the client side
            if (params.error) {
                return
            }

            // creates a new WebRTC Transport to send media
            // based on the server's producer transport params
            // https://mediasoup.org/documentation/v3/mediasoup-client/api/#TransportOptions
            producerTransport = device.createSendTransport(params)

            // https://mediasoup.org/documentation/v3/communication-between-client-and-server/#producing-media
            // this event is raised when a first call to transport.produce() is made
            // see connectSendTransport() below
            producerTransport.on('connect', async ({ dtlsParameters }, callback, errback) => {
                try {
                    // Signal local DTLS parameters to the server side transport
                    // see server's socket.on('transport-connect', ...)
                    await socketRoomRef.current.emit('transport-connect', {
                        dtlsParameters,
                    })

                    // Tell the transport that parameters were transmitted.
                    callback()

                } catch (error) {
                    errback(error)
                }
            })

            producerTransport.on('produce', async (parameters, callback, errback) => {


                try {

                    // await socketRoomRef.current.emit('transport-produce', {
                    //     kind: parameters.kind,
                    //     rtpParameters: parameters.rtpParameters,
                    //     participant: currentParticipant,
                    // }, ({ id, producersExist }) => {
                    //     callback({ id })


                    //     if (producersExist) getProducers()
                    // })

                    await socketRoomRef.current.emit('transport-produce', {
                        kind: parameters.kind,
                        rtpParameters: parameters.rtpParameters,
                        participant: currentParticipant,
                    }, ({ id, producersExist }) => {
                        callback({ id });

                        // ⚠️ Adaugă un delay de siguranță înainte de getProducers
                        if (producersExist) {
                            setTimeout(() => {
                                getProducers();
                            }, 1000);
                        }
                    });
                } catch (error) {
                    errback(error)
                }
            })

            connectSendTransport()
        })
    }

    const connectSendTransport = async () => {
        // we now call produce() to instruct the producer transport
        // to send media to the Router
        // https://mediasoup.org/documentation/v3/mediasoup-client/api/#transport-produce
        // this action will trigger the 'connect' and 'produce' events above

        var iamModerator = (currentConference?.type === "Conference" && currentConference?.topics[0]?.moderator._id === currentParticipant?._id) ||
            iamSubAdministrator ||
            ((currentConference?.type === "Presentation" || currentConference?.type === "Meeting") && currentParticipant?._id === currentConference.moderatedBy);

        if ((ioSettings && ioSettings.audio) || iamModerator) {
            audioProducer = await producerTransport.produce(audioParamsRef.current);
            audioProducer.on('trackended', () => {
            })

            audioProducer.on('transportclose', () => {
            })
        }

        if (!ioSettings || ioSettings.video) {
            videoProducer = await producerTransport.produce(videoParamsRef.current);

            videoProducer.on('trackended', () => {
            })

            videoProducer.on('transportclose', () => {
            })
        }
    }

    const signalNewConsumerTransport = async (remoteProducerId) => {
        //check if we are already consuming the remoteProducerId
        if (consumingTransports.includes(remoteProducerId)) return;
        consumingTransports.push(remoteProducerId);

        await socketRoomRef.current.emit('createWebRtcTransport', { consumer: true }, ({ params }) => {
            // The server sends back params needed 
            // to create Send Transport on the client side
            if (params.error) {
                return
            }

            let consumerTransport
            try {
                consumerTransport = device.createRecvTransport(params)
            } catch (error) {
                return
            }

            consumerTransport.on('connect', async ({ dtlsParameters }, callback, errback) => {
                try {
                    // Signal local DTLS parameters to the server side transport
                    // see server's socket.on('transport-recv-connect', ...)
                    await socketRoomRef.current.emit('transport-recv-connect', {
                        dtlsParameters,
                        serverConsumerTransportId: params.id,
                    })

                    // Tell the transport that parameters were transmitted.
                    callback()
                } catch (error) {
                    // Tell the transport that something was wrong
                    errback(error)
                }
            })

            connectRecvTransport(consumerTransport, remoteProducerId, params.id)
        })
    }

    // server informs the client of a new producer just joined


    const getProducers = () => {
        socketRoomRef.current.emit('getProducers', producerIds => {
            // for each of the producer create a consumer
            producerIds.forEach(signalNewConsumerTransport)
        })
    }

    const connectRecvTransport = async (consumerTransport, remoteProducerId, serverConsumerTransportId) => {
        // for consumer, we need to tell the server first
        // to create a consumer based on the rtpCapabilities and consume
        // if the router can consume, it will send back a set of params as below
        await socketRoomRef.current.emit('consume', {
            rtpCapabilities: device.rtpCapabilities,
            remoteProducerId,
            serverConsumerTransportId,
        }, async ({ params }) => {
            if (params.error) {
                return
            }

            // then consume with the local consumer transport
            // which creates a consumer
            const consumer = await consumerTransport.consume({
                id: params.id,
                producerId: params.producerId,
                kind: params.kind,
                rtpParameters: params.rtpParameters
            })

            consumerTransports = [
                ...consumerTransports,
                {
                    consumerTransport,
                    serverConsumerTransportId: params.id,
                    producerId: remoteProducerId,
                    consumer,
                },
            ]

            // create a new div element for the new consumer media

            const { track } = consumer;

            if (params.kind === 'audio') {
                setParticipantsStreams(prev => {
                    const existing = prev.find(p => p.participant._id === params.participant._id);
                    const newAudioStream = new MediaStream([track]);

                    if (existing) {
                        return prev.map(p => p.participant._id === params.participant._id ? { ...p, audioStream: newAudioStream, audioRemoteProducerId: remoteProducerId } : p);
                    } else {
                        return [...prev, { audioRemoteProducerId: remoteProducerId, participant: params.participant, audioStream: newAudioStream }];
                    }
                });
            } else {
                setParticipantsStreams(prev => {
                    const existing = prev.find(p => p.participant._id === params.participant._id);
                    const newVideoStream = new MediaStream([track]);

                    if (existing) {
                        return prev.map(p => p.participant._id === params.participant._id ? { ...p, videoStream: newVideoStream, videoRemoteProducerId: remoteProducerId } : p);
                    } else {
                        return [...prev, { videoRemoteProducerId: remoteProducerId, participant: params.participant, videoStream: newVideoStream }];
                    }
                });
            }

            socketRoomRef.current.emit('consumer-resume', { serverConsumerId: params.serverConsumerId })
        })
    }

    useEffect(() => {
        if (videoParamsRef.current?.track) {
            videoParamsRef.current.track.enabled = !videoMuted;
        }
    }, [videoMuted])

    useEffect(() => {
        if (audioParamsRef.current?.track) {
            audioParamsRef.current.track.enabled = !micMuted;
        }
    }, [micMuted])




    return (
        <div style={{ position: "relative", width: "100%", height: "100%", backgroundColor: "transparent" }}>
            <div ref={remoteVideosContainerRef} style={{ width: "auto", padding: "10px", position: "absolute", height: "100%", right: "10px", display: "flex", flexDirection: "column", justifyContent: "center", flexWrap: "wrap-reverse" }}>
                {participantsStreams.map((participantStreams) => <div key={participantStreams.participant._id}>
                    {/* {currentModeratorStream?.participant._id !== participantStreams.participant._id && <ParticipantStreamComponent */}
                    {<ParticipantStreamComponent
                        audioStream={participantStreams.audioStream}
                        videoStream={participantStreams.videoStream}
                        participant={participantStreams.participant}
                        height={videoElementHeight}
                    />}
                </div>)}
            </div>

            {ioSettings && !currentConference.videoPaused && <div className={styles.ioDevicesComp}>
                {ioSettings.video && <div className={videoMuted ? styles.ioDeviceButtonMuted : styles.ioDeviceButton} onClick={() => setVideoMuted(!videoMuted)}>
                    <FontAwesomeIcon icon={byPrefixAndName.fal[videoMuted ? 'camera-web-slash' : 'camera-web']} />

                </div>}
                {ioSettings.audio && <div className={micMuted ? styles.ioDeviceButtonMuted : styles.ioDeviceButton} onClick={() => setMicMuted(!micMuted)}>
                    <FontAwesomeIcon icon={byPrefixAndName.fal[micMuted ? 'microphone-slash' : 'microphone']} />
                </div>}
                {/* <div className={devicesListOpen ? styles.ioDeviceButtonOpened : styles.ioDeviceButton} onClick={() => setDevicesListOpen(!devicesListOpen)}>
                                <FontAwesomeIcon icon={byPrefixAndName.fal['sliders']} />
                            </div> */}
            </div>}
        </div>
    );
}

export default MediasoupConferenceComponentNew;
